var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from "react";
import styled from "styled-components";
import { InputLabel, MenuItem, Select } from "@material-ui/core";
import { useDispatch } from "react-redux";
import * as quizAnswerActions from "../../state/quizAnswer/actions";
import { useTypedSelector } from "../../state/store";
var StyledSelect = styled(Select)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));

var AnswerComponent = function AnswerComponent(_a) {
  var direction = _a.direction,
      themeProvider = _a.themeProvider,
      options = _a.options,
      quizDisabled = _a.quizDisabled,
      quizItemId = _a.quizItemId;
  var dispatch = useDispatch();

  var handleChange = function handleChange(event) {
    var optionId = event.target.value;
    dispatch(quizAnswerActions.changeChosenOption(quizItemId, optionId));
  };

  var quizItemAnswer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer.itemAnswers.find(function (ia) {
      return ia.id === quizItemId;
    });
  });
  var selectedOptionIds = (quizItemAnswer === null || quizItemAnswer === void 0 ? void 0 : quizItemAnswer.optionAnswers.map(function (oA) {
    return oA.quizOptionId;
  })) || [];
  var selectedOption = selectedOptionIds[0];
  return React.createElement(React.Fragment, null, React.createElement(InputLabel, {
    id: "demo-simple-select-outlined-label"
  }, "select an option"), React.createElement(StyledSelect, {
    labelId: "demo-simple-select-outlined-label",
    id: "demo-simple-select-filled",
    direction: direction,
    value: selectedOption,
    providedStyles: themeProvider.optionContainerStyles,
    onChange: handleChange
  }, options.sort(function (o1, o2) {
    return o1.order - o2.order;
  }).map(function (option, index) {
    var optionIsSelected = option.id === selectedOption;
    return React.createElement(MenuItem, {
      selected: !!optionIsSelected,
      disabled: quizDisabled,
      "aria-pressed": optionIsSelected,
      key: option.id,
      value: option.id
    }, option.title);
  })));
};

export default AnswerComponent;
var templateObject_1;